import {Button, Stack} from '@mui/material';
import React from 'react';

import {AlertModal} from 'presentation/components';
import {FailToCompleteActionModalProps} from './types';

export function FailToCompleteActionModal({
	open,
	setOpen,
	handleTryAgain,
	fallbackAction,
	headerTitle,
	description,
	title,
	primaryActionText,
	secondaryActionText,
	reversedFooter,
	dataTagId,
	headerDataTagId,
	primaryBtnDataTagId,
	secondaryBtnDataTagId,
}: FailToCompleteActionModalProps) {
	const primaryButton = (
		<Button
			data-tag-id={secondaryBtnDataTagId}
			type="submit"
			onClick={handleTryAgain}
			fullWidth
			size="large">
			{primaryActionText}
		</Button>
	);

	const secondaryButton = (
		<Button
			data-tag-id={primaryBtnDataTagId}
			fullWidth
			variant="outlined"
			onClick={fallbackAction}
			size="large">
			{secondaryActionText}
		</Button>
	);

	return (
		<AlertModal
			headerDataTagId={headerDataTagId}
			data-tag-id={dataTagId}
			footerContent={
				<Stack gap={1} width="100%">
					{reversedFooter ? (
						<>
							{primaryButton}
							{secondaryButton}
						</>
					) : (
						<>
							{secondaryButton}
							{primaryButton}
						</>
					)}
				</Stack>
			}
			description={description}
			headerTitle={headerTitle}
			onClose={() => setOpen(false)}
			title={title}
			open={open}
			variant="info"
		/>
	);
}
